module.exports = __webpack_public_path__ + "img/tx.2205cfd2.png";